/**
 * Dev-login roster: the personas shown in the dev login modal, each
 * optionally carrying the admin role it resolves to server-side.
 *
 * Role-holders are listed first (Owner, then the remaining roles) so a
 * developer can quickly sign in as a given role; the rest are plain
 * members reused from `defaultProfileList`. Keys match the server
 * `testingDevelopmentUsers` ids so `signIn.testing({ id })` resolves the
 * intended user. This is intentionally separate from `defaultProfileList`,
 * which is shared by demos and must not be reordered.
 */

import type { UserProfile } from '@repo/shared/orpc/types';
import { defaultProfileList, profileA } from 'util/test-profile-roster';

export type DevLoginPersona = UserProfile & { role?: string };

function faceUrl(face: string) {
    return 'https://psi.newpublic.org/faces/' + face;
}

const roleLoginPersonas: DevLoginPersona[] = [
    { ...profileA, name: 'Alice Admin', role: 'Owner' },
    { profileKey: 'role-editor', name: 'Erin Editor', photoUrl: faceUrl('face1.jpeg'), role: 'Editor' },
    { profileKey: 'role-observer', name: 'Olive Observer', photoUrl: faceUrl('face8.jpeg'), role: 'Observer' },
    { profileKey: 'role-moderator', name: 'Morgan Moderator', photoUrl: faceUrl('face7.jpeg'), role: 'Moderator' },
];

// Members: reuse profiles b–l (skip Alice, index 0, now a role persona above).
const memberLoginPersonas: DevLoginPersona[] = defaultProfileList.slice(1, 12);

export const devLoginPersonas: DevLoginPersona[] = [...roleLoginPersonas, ...memberLoginPersonas];
